(function (window) {

    window.__env = window.__env || {};

    // All environment variables must be here
    window.__env.environment = 'development';
    window.__env.baseUrl = 'https://omg-ml8-st-1.oecd.org';
	//window.__env.baseUrl = 'http://vd-w2k8-java.main.oecd.org:8084';
    //window.__env.directoryUrl = '/OmegaDev/Search/';
	window.__env.directoryUrl = '/';
    window.__env.apiBaseUrl = 'https://omg-ml8-st-1.oecd.org/Omega/API/';
    window.__env.linkServerUrl = 'https://omg-ml8-st-1.oecd.org/';
    window.__env.imageServerBaseUrl = 'http://cdi-app-1.main.oecd.org:8000/img/';
    // use random URL for authServerUrl to test backup local storage (resource, search, history and settings)
    window.__env.authServerUrl = 'https://cdimain.oecd.org:8081/Catema/GetUserName2.asp';
    window.__env.showDictionary = true;

}(this));
